export const imageWidth = 88;
